import React, { useEffect, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { CgChevronRight as ChevronIcon } from 'react-icons/cg'
import { Link, graphql } from 'gatsby'
import { StaticImage, getSrc } from 'gatsby-plugin-image'
import isEqual from 'lodash.isequal'
import { container, heading, paragraph } from '../404.module.css'
import Layout from '../../components/Layout'
import PrimaryButton from '../../components/buttons/Buttons'
import Calculator from '../../components/calculator/Calculator'
import ProductImageCarousel from '../../components/carousel/ProductImageCarousel/ProductImageCarousel'
import { AddToCart } from '../../components/cart/AddToCart/AddToCart'
import { NumericInput } from '../../components/cart/NumericInput/NumericInput'
import ContentContainer from '../../components/content/ContentContainer/ContentContainer'
import CustomersAlsoBought from '../../components/customers-also-bought/CustomersAlsoBought'
import LoadingSpinner from '../../components/loading/LoadingSpinner'
import ColorPicker from '../../components/products/ColorPicker/ColorPicker'
import ComparePrice from '../../components/products/ComparePrice/ComparePrice'
import FaqSection from '../../components/sections/FaqSection/FaqSection'
import FeaturedProductsCarousel from '../../components/sections/FeaturedProductCarousel/FeaturedProductCarousel'
import { Seo } from '../../components/seo'
import { SearchProvider } from '../../context/search-provider'
import comparePrice from '../../utils/comparePrice'
import { formatPrice } from '../../utils/format-price'
import { useMetaobjects } from '../../utils/hooks'
import { richToHTML } from '../../utils/richToHtml'
import {
  active,
  breadcrumb,
  calcBody,
  calcWrap,
  calcimage,
  calculatorDrop,
  calculatorWrapper,
  header,
  horizontal,
  noImagePreview,
  optionalLay,
  optionsWrapper,
  priceWrap,
  productDetailsWrap,
  selectVariant,
  singleSelect,
  totalWrap,
  vertical,
} from './product-page.module.scss'

const sizeOptionValue = (option) => {
  let temp = option.split('x')
  return {
    width: Number(temp[0].substring(0, temp[0].length - 1)),
    length: Number(temp[1].substring(0, temp[1].length - 1)),
  }
}

export default function Product(props) {
  const queryParams = new URLSearchParams(props.location.search)
  const variantParam = queryParams.get('variant')
  const [desiredVariant, setDesiredVariant] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!variantParam || desiredVariant) {
      setIsLoading(false)
    }
  }, [desiredVariant])

  if (!props.data.product) {
    return (
      <Layout>
        <div className={container}>
          <h1 className={heading}>Page Not Found</h1>
          <p className={paragraph}>
            {"Sorry, we couldn't find what you were looking for"}
          </p>
        </div>
      </Layout>
    )
  } else {
    const { product, bestSellers, featuredDeals, allProducts } = props.data
    const [showForm, setShowForm] = React.useState(false)

    console.log(product)

    if (variantParam && !desiredVariant) {
      let item = product.variants.find(
        (variant) =>
          variant.storefrontId ===
          `gid://shopify/ProductVariant/${variantParam}`,
      )

      if (item) {
        setDesiredVariant(item)
      } else {
        setDesiredVariant(product.variants[0])
      }
    }

    let description = product.seo.description
      ? product.seo.description
      : product.description

    let firstImage = product.media[0]
    if (Object.prototype.hasOwnProperty.call(firstImage, 'image')) {
      firstImage = firstImage.image
    }

    let listOfAccessories = product.metafields.find(
      (val) =>
        val.key === 'list_of_accessories' &&
        val.namespace === 'product_page_section',
    )?.value

    if (listOfAccessories) {
      listOfAccessories = JSON.parse(listOfAccessories)
      listOfAccessories = allProducts.nodes.filter((val) =>
        listOfAccessories.includes(val.shopifyId),
      )
    }

    let boughtProducts = product.metafields.find(
      (val) =>
        val.key === 'customers_also_bought' &&
        val.namespace === 'product_page_section',
    )?.value

    if (boughtProducts) {
      boughtProducts = JSON.parse(boughtProducts)
      boughtProducts = allProducts.nodes.filter((val) =>
        boughtProducts.includes(val.shopifyId),
      )
    }

    return (
      <SearchProvider>
        <Layout>
          {firstImage ? (
            <Seo
              title={product.title}
              description={description}
              image={getSrc(firstImage.gatsbyImageData)}
            />
          ) : undefined}
          {isLoading && <LoadingSpinner />}
          <ProductWithMetaobjects
            product={product}
            setShowForm={setShowForm}
            desiredVariant={desiredVariant}
          />
          <ContentContainer>
            {listOfAccessories && (
              <Row>
                <FeaturedProductsCarousel
                  title={'Installation Accessories'}
                  featuredProducts={{ products: listOfAccessories }}
                  showAddToCart={true}
                />
              </Row>
            )}
            {boughtProducts && (
              <Row>
                <CustomersAlsoBought products={boughtProducts} />
              </Row>
            )}
            <Row className='py-5'>
              <Col lg={8} className={productDetailsWrap}>
                <h2>Product Details</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.descriptionHtml,
                  }}
                />
              </Col>
              <Col lg={4}> </Col>
            </Row>
            <Row className='py-5'>
              <FeaturedProductsCarousel
                title={'Best Sellers'}
                featuredProducts={bestSellers}
              />
            </Row>
            <Row className='py-5'>
              <FeaturedProductsCarousel
                title={'Featured Deals'}
                featuredProducts={featuredDeals}
              />
            </Row>
            <ProductFAQs metafields={product.metafields} />
          </ContentContainer>
        </Layout>
      </SearchProvider>
    )
  }
}

function ProductFAQs({ metafields }) {
  let metafieldFaqs = metafields.find((x) => x.key === 'faq')
  let productFaqs = []
  if (metafieldFaqs) {
    const { metaobjects } = useMetaobjects('faq', false, 40)
    productFaqs = metaobjects
      .filter((x) => metafieldFaqs.value.includes(x.id))
      .map((x) => ({ ...x, answer: richToHTML(x.answer) }))
  }

  return (
    <>
      {productFaqs.length > 0 && metafieldFaqs != null && (
        <Row className='py-5'>
          <FaqSection faqs={productFaqs} />
        </Row>
      )}
    </>
  )
}

function ProductWithMetaobjects({ product, setShowForm, desiredVariant }) {
  let {
    options,
    variants,
    priceRangeV2,
    title,
    media,
    metafields,
    collections,
  } = product

  const images = media.map((x) => {
    return { id: x.id, ...x.image }
  })

  const [selectedVariant, setSelectedVariant] = useState(
    desiredVariant || { ...variants[0] },
  )

  const [quantity, setQuantity] = useState(1)
  const [newPrice, setNewPrice] = useState(
    comparePrice(product.metafields, variants[0]),
  )
  const [totalPrice, settotalPrice] = useState([])

  const getVariant = (variant, index, value) => {
    const currentOptions = [...variant.selectedOptions]

    currentOptions[index] = {
      ...currentOptions[index],
      value,
    }

    const selectedVariant = variants.find((variant) => {
      return isEqual(currentOptions, variant.selectedOptions)
    })

    return { ...selectedVariant }
  }

  const handleOptionChange = (index, event) => {
    const value = event.target.value

    if (value === '') {
      return
    }

    const updatedSelectedVariant = getVariant(selectedVariant, index, value)
    setSelectedVariant(updatedSelectedVariant)
  }

  const hasImages = images.length > 0
  const specSheet = product.metafields.find((item) => {
    return item.key === 'specification'
  })

  useEffect(() => {
    setNewPrice(comparePrice(product.metafields, selectedVariant))
  }, [selectedVariant])

  useEffect(() => {
    settotalPrice(quantity * selectedVariant.price)
  }, [selectedVariant, quantity])

  const previousPath =
    (typeof window !== 'undefined' &&
      window.sessionStorage.getItem('prevPath')) ||
    ''

  const mainCollection = calculateMainCollection(
    previousPath,
    collections,
    metafields,
  )

  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'USD',
        value: selectedVariant.price,
        items: [
          {
            item_id: product.shopifyId,
            item_name: title,
            item_category: product.productType,
            item_list_id: mainCollection.shopifyId,
            item_list_name: mainCollection.title,
            item_variant: selectedVariant.title,
            price: selectedVariant.price,
          },
        ],
      },
    })
  }

  return (
    <ContentContainer>
      <Row className='justify-content-center py-5'>
        <div className={breadcrumb}>
          <Link to={'/'}>Home</Link>
          <ChevronIcon size={12} />
          <Link to={`/collections/${mainCollection.handle}/`}>
            {mainCollection.title}
          </Link>
          <ChevronIcon className='d-none d-md-block' size={12} />
          <p className='d-none d-md-block mb-0'>{title}</p>
        </div>
        <Col lg={6} className='me-lg-auto text-center'>
          {hasImages && (
            <ProductImageCarousel images={images} variant={selectedVariant} />
          )}
          {!hasImages && (
            <span className={noImagePreview}>No Preview image</span>
          )}
          {specSheet && (
            <PrimaryButton
              url={specSheet.value}
              variant='link'
              text='Product Spec Sheet'
              arrow
              className='mx-auto mt-2 px-0'
              blank
            >
              Product Spec Sheet
            </PrimaryButton>
          )}
        </Col>
        <Col lg={5} className=''>
          <h1 className={header}>{title}</h1>
          <ComparePrice
            product={product}
            price={newPrice}
            range={priceRangeV2}
          />
          <fieldset className={optionsWrapper}>
            <Row>
              <ProductVariants
                variants={variants}
                options={options}
                getVariant={getVariant}
                selectedVariant={selectedVariant}
                setSelectedVariant={setSelectedVariant}
                handleOptionChange={handleOptionChange}
              />
            </Row>
          </fieldset>
          {newPrice.oneCover && product.productType !== 'TilesWithTypes' ? (
            <fieldset className={optionsWrapper}>
              <CalculatorAndDirection
                newPrice={newPrice}
                productType={product.productType}
                quantity={quantity}
                setQuantity={setQuantity}
                options={options}
                handleOptionChange={handleOptionChange}
              />
            </fieldset>
          ) : null}
          <Row className={`mt-3 border ${calcWrap}`}>
            <Col xs={6} sm={6}>
              <label className='label d-block mb-2'>Qty</label>
              {product.productType !== 'TilesWithTypes' && (
                <NumericInput
                  aria-label='Quantity'
                  onIncrement={() => setQuantity(Number(quantity) + 1)}
                  onDecrement={() => setQuantity(Math.max(1, quantity - 1))}
                  onChange={(event) => setQuantity(event.currentTarget?.value)}
                  value={quantity}
                />
              )}
            </Col>
            <Col className={totalWrap} xs={6} lg={6}>
              <div className={`position-absolute ${priceWrap}`}>
                <span className='d-block'>
                  {formatPrice(
                    priceRangeV2.minVariantPrice.currencyCode,
                    totalPrice,
                  )}
                </span>
                <span className='d-block strike'>
                  {formatPrice(
                    priceRangeV2.minVariantPrice.currencyCode,
                    totalPrice / 0.75,
                  )}
                </span>
              </div>
            </Col>
          </Row>
          <AddToCart
            variants={[
              {
                id: selectedVariant.storefrontId,
                available: selectedVariant.availableForSale,
                category: product.collections[0].title,
                quantity: quantity,
              },
            ]}
            dataLayer={{
              event: 'add_to_cart',
              ecommerce: {
                currency: 'USD',
                value: selectedVariant.price,
                items: [
                  {
                    item_id: product.shopifyId,
                    item_name: product.title,
                    item_category: product.productType,
                    item_list_id: mainCollection.shopifyId,
                    item_list_name: mainCollection.title,
                    item_variant: selectedVariant.title,
                    price: selectedVariant.price,
                  },
                ],
              },
            }}
          />
        </Col>
      </Row>
    </ContentContainer>
  )
}

export const query = graphql`
  query ($id: String!) {
    product: shopifyProduct(
      id: { eq: $id }
      collections: { elemMatch: { handle: { ne: "hidden" } } }
    ) {
      title
      shopifyId
      description
      descriptionHtml
      productType
      collections {
        shopifyId
        title
        handle
      }
      tags
      priceRangeV2 {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      storefrontId
      media {
        ... on ShopifyMediaImage {
          id
          image {
            altText
            gatsbyImageData(layout: CONSTRAINED, width: 550, aspectRatio: 1)
          }
        }
      }
      metafields {
        namespace
        key
        value
      }
      variants {
        availableForSale
        storefrontId
        title
        price
        metafields {
          key
          value
        }
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        shopifyId
      }
      seo {
        description
      }
    }
    allProducts: allShopifyProduct {
      nodes {
        shopifyId
        title
        productType
        media {
          ... on ShopifyMediaImage {
            image {
              gatsbyImageData
            }
          }
        }
        metafields {
          key
          value
        }
        options {
          name
          values
        }
        tags
        descriptionHtml
        variants {
          price
          compareAtPrice
          inventoryQuantity
          storefrontId
          availableForSale
          selectedOptions {
            name
            value
          }
          metafields {
            key
            value
          }
          image {
            gatsbyImageData
          }
          title
        }
        handle
        priceRangeV2 {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        collections {
          title
        }
      }
    }
    bestSellers: shopifyCollection(handle: { eq: "best-sellers" }) {
      title
      handle
      products {
        title
        productType
        media {
          ... on ShopifyMediaImage {
            image {
              gatsbyImageData
            }
          }
        }
        metafields {
          key
          value
        }
        options {
          name
          values
        }
        tags
        variants {
          price
          compareAtPrice
          inventoryQuantity
          selectedOptions {
            name
            value
          }
          metafields {
            key
            value
          }
          image {
            gatsbyImageData
          }
          title
        }
        handle
        priceRangeV2 {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        collections {
          title
        }
      }
    }
    featuredDeals: shopifyCollection(handle: { eq: "featured-deals" }) {
      title
      handle
      products {
        title
        productType
        media {
          ... on ShopifyMediaImage {
            image {
              gatsbyImageData
            }
          }
        }

        metafields {
          key
          value
        }
        options {
          name
          values
        }
        tags
        variants {
          price
          compareAtPrice
          inventoryQuantity
          selectedOptions {
            name
            value
          }
          metafields {
            key
            value
          }
          image {
            gatsbyImageData
          }
          title
        }
        handle
        priceRangeV2 {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        collections {
          title
        }
      }
    }
  }
`

function calculateMainCollection(previousPath = '', collections, metafields) {
  let main = collections[0]
  const pathCollection = collections.find((collection) =>
    previousPath.includes(collection.handle),
  )
  if (pathCollection) {
    main = pathCollection
  } else {
    const metaMain = metafields.find(
      (field) =>
        field.key === 'main_collection' && field.namespace === 'custom',
    )
    if (metaMain) {
      const findMain = collections.find(
        (collection) => collection.shopifyId === metaMain.value,
      )

      if (findMain) {
        main = findMain
      }
    }
  }
  return main
}

function getVaraintValue(selectedOptions, selectedKey) {
  return selectedOptions?.find((item) => item?.name === selectedKey)?.value
}

function ProductVariants({
  variants,
  options,
  getVariant,
  selectedVariant,
  setSelectedVariant,
  handleOptionChange,
}) {
  return (
    <>
      {variants.length > 1 &&
        options.map(({ id, name, values }, index) => {
          if (name === 'Color') {
            return (
              <Col lg={12} key={index}>
                <label className='label'>{name}</label>
                <ColorPicker
                  variants={variants}
                  options={values}
                  checkedOption={getVaraintValue(
                    selectedVariant.selectedOptions,
                    'Color',
                  )}
                  onUpdate={(color) =>
                    setSelectedVariant(getVariant(selectedVariant, 0, color))
                  }
                />
              </Col>
            )
          }
          return (
            <Col key={index}>
              <label className='label'>{name}</label>
              {values.length > 1 ? (
                <div className={selectVariant} key={id}>
                  <select
                    id={name}
                    aria-label='Variants'
                    onChange={(event) => handleOptionChange(index, event)}
                    className='border'
                    value={getVaraintValue(
                      selectedVariant?.selectedOptions,
                      name,
                    )}
                  >
                    {values.map((value) => (
                      <option value={value} key={`${name}-${value}`}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <div
                  id={name}
                  value={
                    getVaraintValue(selectedVariant.selectedOptions, name) ||
                    values[0]
                  }
                  className={singleSelect}
                >
                  {' '}
                  {getVaraintValue(selectedVariant.selectedOptions, name) ||
                    values[0]}{' '}
                </div>
              )}
            </Col>
          )
        })}
    </>
  )
}

function CalculatorAndDirection({
  newPrice,
  productType,
  quantity,
  setQuantity,
  options,
  handleOptionChange,
}) {
  // Updates Sqft
  const [sqft, setSqft] = useState({ total: 0, width: 0, length: 0 })
  const [bestVerticalOption, setBestVerticalOption] = React.useState()
  const [bestHorizontalOption, setBestHorizontalOption] = React.useState()
  const [selectedDirectonOption, setSelectedDirectonOption] = React.useState(1)

  // Updates the quantity based on the sqft state from calculator.
  useEffect(() => {
    if (!sqft || sqft.total == 0) {
      return
    }

    if (productType === 'Tiles' || productType === 'BoxedTiles') {
      setQuantity(Math.ceil(sqft.total / newPrice.oneCover))
      return
    } else if (productType === 'PreCutRoll') {
      const nearestLength = Math.min(Math.ceil(sqft.length / 5) * 5, 50)
      const nearestWidth = Math.min(Math.ceil(sqft.width / 5) * 5, 50)
      const sizeOptionsIndex = options.findIndex((val) => val.name === 'Size')
      const sizeOptions = options[sizeOptionsIndex]
      const verticalOption =
        sizeOptions.values.find((option) => option.includes(nearestLength)) ||
        sizeOptions.values[0]
      const horizontalOption =
        sizeOptions.values.find((option) => option.includes(nearestWidth)) ||
        sizeOptions.values[0]

      const verticalOptionValue = sizeOptionValue(verticalOption)

      const horizontalOptionValue = sizeOptionValue(horizontalOption)

      const verticalQuantity =
        Math.ceil(sqft.width / verticalOptionValue.width) *
          Math.ceil(nearestLength / verticalOptionValue.length) +
        Math.max(
          0,
          Math.ceil(
            ((sqft.length - nearestLength) * sqft.width) /
              (verticalOptionValue.width * verticalOptionValue.length),
          ),
        )

      const horizontalQuantity =
        Math.ceil(sqft.length / horizontalOptionValue.width) *
          Math.ceil(nearestWidth / horizontalOptionValue.length) +
        Math.max(
          0,
          Math.ceil(
            (sqft.length * (sqft.width - nearestWidth)) /
              (horizontalOptionValue.width * horizontalOptionValue.length),
          ),
        )

      setBestVerticalOption({
        option: verticalOption,
        value: nearestLength,
        quantity: verticalQuantity,
      })
      setBestHorizontalOption({
        option: horizontalOption,
        value: nearestWidth,
        quantity: horizontalQuantity,
      })

      let element = document.getElementById('Size')
      if (selectedDirectonOption === 1) {
        setQuantity(verticalQuantity)
        handleOptionChange(sizeOptionsIndex, {
          target: { value: verticalOption },
        })
        if (element != null) {
          element.value = verticalOption
        }
      } else if (selectedDirectonOption === 2) {
        setQuantity(horizontalQuantity)
        handleOptionChange(sizeOptionsIndex, {
          target: { value: horizontalOption },
        })
        if (element != null) {
          element.value = horizontalOption
        }
      }
    }
  }, [sqft, selectedDirectonOption])

  return (
    <Accordion
      className='calculator-accordion'
      flush
      defaultActiveKey={['0']}
      alwaysOpen
    >
      <Accordion.Item className={calculatorDrop}>
        <Accordion.Header className='mt-3 border'>
          {' '}
          {newPrice.oneCover && productType !== 'TilesWithTypes' ? (
            <span className='d-block small'>
              Current Qty Covers:{' '}
              <strong>{newPrice.oneCover * quantity} sqft</strong>
            </span>
          ) : null}
          <div className={calculatorWrapper}>
            <StaticImage
              src='../../assets/images/calculator-icon.png'
              alt='roll-vertical-icon'
              width={40}
              className={`mx-md-0 mx-4 ${calcimage}`}
            />
          </div>
        </Accordion.Header>
        <Accordion.Body className={calcBody}>
          <Calculator onUpdate={setSqft} />
          {productType === 'PreCutRoll' && (
            <div className={optionalLay}>
              <div
                className={`${vertical} ${
                  selectedDirectonOption === 1 && active
                }`}
                onClick={() => setSelectedDirectonOption(1)}
              >
                <div className='option-box'>
                  <label>Option 1</label>
                  {bestVerticalOption && (
                    <p>
                      {bestVerticalOption.quantity} Rolls{' '}
                      {bestVerticalOption.option} Ea
                    </p>
                  )}
                </div>
                <StaticImage
                  src='../../../static/roll-vertical.png'
                  alt='roll-vertical-icon'
                  width={150}
                  height={150}
                  className='mx-md-0 mx-4'
                />
              </div>
              <div
                className={`${horizontal} ${
                  selectedDirectonOption === 2 && active
                }`}
                onClick={() => setSelectedDirectonOption(2)}
              >
                <div className='option-box'>
                  <label>Option 2</label>
                  {bestHorizontalOption && (
                    <p>
                      {bestHorizontalOption.quantity} Rolls{' '}
                      {bestHorizontalOption.option} Ea
                    </p>
                  )}
                </div>
                <StaticImage
                  src='../../../static/roll-horizontal.png'
                  alt='roll-horizontal-icon'
                  width={150}
                  height={150}
                  className='mx-md-0 mx-4'
                />
              </div>
            </div>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
